import { render, staticRenderFns } from "./AddAddressForm.vue?vue&type=template&id=21ece6d9&scoped=true&"
import script from "./AddAddressForm.vue?vue&type=script&lang=js&"
export * from "./AddAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ece6d9",
  null
  
)

export default component.exports